module.exports = __webpack_public_path__ + "static/assets/cfb83a43db1bfaaace8ceb06bfab2b05.png";